"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _cssClassesHelper = require("../../helpers/cssClassesHelper");
var _RecentActivityHeader = _interopRequireDefault(require("./RecentActivityHeader"));
var _RecentActivityTable = _interopRequireDefault(require("./RecentActivityTable"));
require("./ActivityComponents.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var baseClasses = (0, _cssClassesHelper.getBEMClasses)('activity');
var RecentActivityComponent = function RecentActivityComponent(props) {
  var width = props.width,
    themeModifier = props.themeModifier;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: baseClasses()
  }, /*#__PURE__*/_react["default"].createElement(_RecentActivityHeader["default"], null), /*#__PURE__*/_react["default"].createElement(_RecentActivityTable["default"], {
    themeModifier: themeModifier,
    width: width
  }));
};
var _default = exports["default"] = RecentActivityComponent;